import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import * as playerActions from './playerActions';
import { exhaustMap, map, catchError, tap } from 'rxjs/operators';
import { PlayerService } from '../../services/player/player.service';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { Profile } from '../../modules/player/profile';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login/login.service';
import { GameLaunchURLs } from '../../modules/player/gameLaunchURLs';
import { TournamentsList } from '../../modules/player/tournamentsList';
import { Stats } from '../../modules/player/stats';
import { GameHistoryData } from '../../modules/gamehistory';
import { RemoteGamesHistory } from '../../modules/remotegamehistory/remotegamehistory';
import { CashierService } from '../../services/cashier/cashier.service';
import { GamesService } from '../../services/games/games.service';

const handleError = (error: any, actions: any) => {
    if (error.error instanceof Error) {
        return of(new actions({ "message": error.error.message }));
    } else {
        try {
            if (error.error.message) {
                return of(new actions({ "message": error.error.message }));
            } else if (error.message) {
                return of(new actions({ "message": error.message }));
            }
            return of(new actions({ "message": "Something went wrong, please contact admin" }));
        } catch (error) {
            // Handle parsing error silently
        }
    }
    return of(new actions({ "message": "Something went wrong, please contact admin" }));
}

@Injectable()
export class PlayerEffects {
    constructor(
        private actions$: Actions,
        private playerService: PlayerService,
       
        private router: Router,
        private loginservice: LoginService,
        private cashierservice: CashierService
    ) { }

    playerGetProfile$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_PROFILE),
        exhaustMap((action: playerActions.PlayerGetProfile) =>
            this.playerService.onPlayerGetProfile().pipe(
                map((response: Profile) => new playerActions.PlayerGetProfileSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerGetProfileFail))
            )
        )
    ));

    playerGetProfileSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_PROFILE_SUCCESS),
        tap((action: playerActions.PlayerGetProfileSuccess) => {
            if (action.payload.code) {
                if (action.payload.code === "SESSION_EXPIRED") {
                    this.cashierservice.sessionExpire(true);
                    this.loginservice.onPlayerLoggedIn(false);
                } else {
                    this.cashierservice.sessionExpire(false);
                }
            }
            if (action.payload.success === true) {
                sessionStorage.setItem('profile', action.payload.login);
                this.loginservice.onPlayerLoggedIn(true);
               
            }
        })
    ), { dispatch: false });

    playerUpdateProfile$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_UPDATE_PROFILE),
        exhaustMap((action: playerActions.PlayerUpdateProfile) =>
            this.playerService.onPlayerUpdateProfile(action.payload).pipe(
                map((response: Profile) => new playerActions.PlayerUpdateProfileSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerUpdateProfileFail))
            )
        )
    ));

    // playerUpdateProfileSuccess$ = createEffect(() => this.actions$.pipe(
    //     ofType(playerActions.PLAYER_UPDATE_PROFILE_SUCCESS),
    //     tap((action: playerActions.PlayerUpdateProfileSuccess) => {
    //         if (action.payload.code) {
    //             if (action.payload.code === "SESSION_EXPIRED") {
    //                 this.loginservice.onPlayerLoggedIn(false);
    //             } else {
    //                 this.router.navigate(["/profile"]);
    //             }
    //         }
    //     })
    // ), { dispatch: false });

    playerUpdatePassword$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_UPDATE_PASSWORD),
        exhaustMap((action: playerActions.PlayerUpdatePassword) =>
            this.playerService.onPlayerUpdatePassword(action.payload).pipe(
                map((response: Profile) => new playerActions.PlayerUpdatePasswordSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerUpdatePasswordFail))
            )
        )
    ));

    playerGetLaunchURLs$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_LAUNCHURLS),
        exhaustMap((action: playerActions.PlayerGetLaunchURLs) =>
            this.playerService.onPlayerGetLaunchURLs().pipe(
                map((response: GameLaunchURLs) => new playerActions.PlayerGetLaunchURLsSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerGetLaunchURLsFail))
            )
        )
    ));

    playerGetLaunchURLsSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_LAUNCHURLS_SUCCESS),
        tap((action: playerActions.PlayerGetLaunchURLsSuccess) => {
            this.playerService.launchFlashGame(action.payload);
        })
    ), { dispatch: false });

    playerGetGameHistory$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_GAME_HISTORY),
        exhaustMap((action: playerActions.PlayerGetGameHistory) =>
            this.playerService.onPlayerGetGameHistory(action.payload).pipe(
                map((response: GameHistoryData) => new playerActions.PlayerGetGameHistorySuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerGetGameHistoryFail))
            )
        )
    ));

    playerGetTournamentsList$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_TOURNAMENTS_LIST),
        exhaustMap((action: playerActions.PlayerGetTournamentsList) =>
            this.playerService.onPlayerGetTournamentsList(action.payload).pipe(
                map((response: TournamentsList) => new playerActions.PlayerGetTournamentsListSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerGetTournamentsListFail))
            )
        )
    ));

    playerGetTournamentsListSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_TOURNAMENTS_LIST_SUCCESS),
        tap((action: playerActions.PlayerGetTournamentsListSuccess) => {
            // Handle success (currently empty)
        })
    ), { dispatch: false });

    playerGetStats$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_STATS),
        exhaustMap((action: playerActions.PlayerGetStats) =>
            this.playerService.onPlayerGetStats().pipe(
                map((response: Stats) => new playerActions.PlayerGetStatsSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerGetStatsFail))
            )
        )
    ));

    playerGetPlayerLevels$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_PLAYERLEVELS),
        exhaustMap((action: playerActions.PlayerGetPlayerLevels) =>
            this.playerService.onPlayerGetPlayerLevels().pipe(
                map((response) => new playerActions.PlayerGetPlayerLevelsSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerGetPlayerLevelsFail))
            )
        )
    ));

    playerLeaderBoardList$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_LEADERBORAD_LIST),
        exhaustMap((action: playerActions.PlayerLeaderBoardList) =>
            this.playerService.onPlayerLeaderBoardList().pipe(
                map((response) => new playerActions.PlayerLeaderBoardListSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerLeaderBoardListFail))
            )
        )
    ));

    playerLeaderBoardGetParticipants$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_LEADERBORAD_GET_PARTICIPANTS),
        exhaustMap((action: playerActions.PlayerLeaderBoardGetParticipants) =>
            this.playerService.onPlayerLeaderBoardGetParticipants().pipe(
                map((response) => new playerActions.PlayerLeaderBoardGetParticipantsSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerLeaderBoardGetParticipantsFail))
            )
        )
    ));

    PlayerGetRemoteGameHistory$ = createEffect(() => this.actions$.pipe(
        ofType(playerActions.PLAYER_GET_REMOTE_GAME_HISTORY),
        exhaustMap((action: playerActions.PlayerGetRemoteGameHistory) =>
            this.playerService.onPlayerGetRemoteGameHistory(action.payload).pipe(
                map((response: RemoteGamesHistory) => new playerActions.PlayerGetRemoteGameHistorySuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, playerActions.PlayerGetRemoteGameHistoryFail))
            )
        )
    ));
}
